import EFOcats_pattern_seimei from './efocats_pattern_seimei';

export default class EFOcats_pattern_factory {
  static create(name, efocats, opt) {
    let instance;
    switch (name) {
      case 'single-hiragana':
        // 姓名入力（１ページでひらなが変換）
        instance = new EFOcats_pattern_seimei('hiragana', 'single', opt);
        break;
      case 'single-katakana':
        // 姓名入力（１ページでひらなが変換）
        instance = new EFOcats_pattern_seimei('kana', 'single', opt);
        break;
      case 'double-hiragana':
        // 姓名入力（2ページでひらなが変換）
        instance = new EFOcats_pattern_seimei('hiragana', 'double', opt);
        break;
      case 'double-katakana':
        // 姓名入力（2ページでひらなが変換）
        instance = new EFOcats_pattern_seimei('kana', 'double', opt);
        break;
      default:
        return;
    }

    // 自身のインスタンスを各処理に通知する
    efocats.settingdata.patterns.push(instance);
  }
}
